import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { WebStorage } from './web-storage';

@Injectable({
    providedIn: 'root'
})
export class SessionStorageService implements WebStorage {
    private sessionStorage = window.sessionStorage;

    // Subject para notificar quando o clearAll for chamado
    private clearAllSubject = new Subject<void>();

    // Observable público que outros serviços podem assinar
    public clearAllSessionStorage$ = this.clearAllSubject.asObservable();

    set(key: string, value: string) {
        this.sessionStorage.setItem(key, value);
    }

    get(key: string, defaultValue = null): string {
        return this.sessionStorage.getItem(key) || defaultValue;
    }

    setObject(key: string, value: Object) {
        this.sessionStorage.setItem(key, JSON.stringify(value));
    }

    getObject(key: string): Object {
        return JSON.parse(this.sessionStorage.getItem(key));
    }

    remove(key: string) {
        this.sessionStorage.removeItem(key);
    }

    clearAll() {
        // Limpa o Session Storage
        this.sessionStorage.clear();
        // Emite um evento para todos os assinantes
        this.clearAllSubject.next();
    }
}
